import router from './router'
import store from './store/'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

const whiteList = ['/login', '/register', '/resetPassword']

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = to.meta.title || '漳州工业设计网'

  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const user = store.getters.user
      if (user) {
        // 检查路由需要的角色权限
        const requiredRoles = to.meta && to.meta.requiredRoles
        if (requiredRoles && requiredRoles.length > 0 && requiredRoles.indexOf(user.role) === -1) {
          // 无权限，阻止进入并返回上一页或跳转欢迎页
          if (from && from.fullPath && from.fullPath !== to.fullPath) {
            next(from.fullPath)
          } else {
            next('/admin/welcome')
          }
          NProgress.done()
          return
        }
        next()
      } else {
        await store.dispatch('user/init')
        // path with arguments
        next(to.fullPath)
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
